import { ILowesStormDoorHandleEditingModel } from "../entities-generated/models/lowes-storm-door-handle/lowes-storm-door-handle-editing-model";
import { ILowesStormDoorHandleListing } from "../entities-generated/models/lowes-storm-door-handle/lowes-storm-door-handle-listing";
import { IPublishLowesStormDoorHandleRequest } from "../entities-generated/models/lowes-storm-door-handle/publish-lowes-storm-door-handle-request";
import { ApiClient } from "./admin-api-client";

class LowesStormDoorHandleApiClientClass {
  public getImportedStormDoorHandleList() {
    return ApiClient.get<ILowesStormDoorHandleListing[]>('lowes-storm-door-handle');
  }

  public getImportedStormDoorHandle(handleId: string) {
    return ApiClient.get<ILowesStormDoorHandleEditingModel>(`lowes-storm-door-handle/${handleId}`);
  }

  public publishStormDoorHandle(request: IPublishLowesStormDoorHandleRequest, handleId: string) {
    return ApiClient.post<void>(`lowes-storm-door-handle/${handleId}`, request);
  }
}

export const LowesStormDoorHandleApiClient = new LowesStormDoorHandleApiClientClass();